// import * as Sentry from '@sentry/browser';

export default {
  async error(...args) {
    console.error(...args);
  },
};
